jQuery(function ($) {
  var $tabs = $('.news-hub-tabs');
  if (!$tabs.length) return;

  $tabs.each(function () {
    var $wrap = $(this);
    var $list = $wrap.find('.news-hub-tabs__list');
    var $prev = $wrap.find('[data-tabs-scroll="prev"]');
    var $next = $wrap.find('[data-tabs-scroll="next"]');
    var list = $list.get(0);

    function updateOverflow() {
      var overflowing = list.scrollWidth > list.clientWidth + 1;
      $wrap.toggleClass('has-overflow', overflowing);
      if (overflowing) updateArrows();
    }

    function updateArrows() {
      var atStart = list.scrollLeft <= 0;
      var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
      $prev.prop('disabled', atStart);
      $next.prop('disabled', atEnd);
    }

    function scrollBy(direction) {
      var amount = list.clientWidth * 0.8 * direction;
      // CSS `scroll-behavior: smooth` on the list drives the animation —
      // a plain scrollLeft assignment is more broadly reliable than
      // passing behavior via the scrollBy() options object.
      list.scrollLeft += amount;
    }

    $prev.on('click', function () { scrollBy(-1); });
    $next.on('click', function () { scrollBy(1); });
    $list.on('scroll', updateArrows);

    updateOverflow();
    $(window).on('resize', updateOverflow);
  });
});
